export enum ListEntitiesVisibilityEnum {
    all,
    visible,
    hidden
}
